export var contextKeys = {
  CATEGORY: 'userTrackingCategoryKey',
  ACTION: 'userTrackingActionKey',
  LABEL: 'userTrackingLabelKey',
  VALUE: 'userTrackingValueKey'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/util-user-tracking/es/constants.js
// module id = 488
// module chunks = 1